import { render, staticRenderFns } from "./moduler.vue?vue&type=template&id=4626c570&scoped=true"
import script from "./moduler.vue?vue&type=script&lang=js"
export * from "./moduler.vue?vue&type=script&lang=js"
import style0 from "./moduler.vue?vue&type=style&index=0&id=4626c570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4626c570",
  null
  
)

export default component.exports